import { Component, h, Prop } from '@stencil/core'

import { colorClasses } from '../../utils/css'

@Component({
  tag: 'ui-pointer',
})
export class Pointer {
  @Prop() direction: 'left' | 'right' | 'up' | 'down' = 'up'
  @Prop() width = 16
  @Prop() height = 8
  @Prop() fillColor = 'white'
  @Prop() strokeColor = 'transparent'
  @Prop() strokeWidth = 0
  @Prop() pointPct = 0.5

  strokeEl: SVGPolygonElement
  fillEl: SVGPolylineElement

  componentDidUpdate() {
    const w = this.width - this.strokeWidth
    const h = this.height - this.strokeWidth
    const o = this.strokeWidth / 2
    const d = w * this.pointPct

    const points = {
      left: [
        [h, o],
        [o, d],
        [h, w],
      ],
      right: [
        [o, o],
        [h, d],
        [o, w],
      ],
      up: [
        [o, h],
        [d, o],
        [w, h],
      ],
      down: [
        [o, o],
        [d, h],
        [w, o],
      ],
    }
    const attr = points[this.direction].map((p) => p.join(' ')).join()
    this.fillEl.setAttribute('points', attr)
    this.strokeEl.setAttribute('points', attr)
  }

  componentDidLoad() {
    this.componentDidUpdate()
  }

  render() {
    const isHorizontal = ['up', 'down'].includes(this.direction)
    const width = isHorizontal ? this.width : this.height
    const height = isHorizontal ? this.height : this.width
    return (
      <svg width={width} height={height}>
        <polygon
          ref={(el) => (this.fillEl = el as SVGPolygonElement)}
          class={`fill-current ${colorClasses({ text: this.fillColor })}`}
        />
        <polyline
          ref={(el) => (this.strokeEl = el as SVGPolylineElement)}
          class={`stroke-current ${colorClasses({ text: this.strokeColor })}`}
          fill='none'
          stroke-width={this.strokeWidth}
          vector-effect='non-scaling-stroke'
        />
      </svg>
    )
  }
}
